module.exports = __webpack_public_path__ + "static/img/he11.15975b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he11.png
// module id = DpFL
// module chunks = 1